import React, { useState, useEffect } from 'react';
import './StatusBar.css';

const StatusBar = ({ message, type = 'success' }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (message) {
      setVisible(true); // Show the status bar when message is set
      const timer = setTimeout(() => {
        setVisible(false); // Hide the status bar after 3 seconds
      }, 3000);
      return () => clearTimeout(timer); // Clean up the timer
    }
  }, [message]);

  return (
    <div className={`status-bar ${type} ${visible ? 'show' : ''}`}>
      <p>{message}</p>
    </div>
  );
};

export default StatusBar;
